var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "remix-icons_line_system_eye-line",
    "data-name": "remix-icons/line/system/eye-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.016,0a9.17,9.17,0,0,1,9.016,7.5A9.169,9.169,0,0,1,0,7.5,9.17,9.17,0,0,1,9.016,0Zm0,13.333A7.5,7.5,0,0,0,16.33,7.5,7.5,7.5,0,0,0,1.7,7.5a7.5,7.5,0,0,0,7.314,5.833Zm0-2.083a3.75,3.75,0,1,1,2.652-1.1A3.75,3.75,0,0,1,9.016,11.25Zm0-1.667a2.083,2.083,0,1,0-1.473-.61A2.083,2.083,0,0,0,9.016,9.583Z",
    transform: "translate(0.984 2.5)",
    fill: "#a2a4ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeVisible);
export default __webpack_public_path__ + "static/media/icon-eye-visible.059381d2c7a0667658cb6e74122c76bf.svg";
export { ForwardRef as ReactComponent };